import { render, staticRenderFns } from "./gamecenter.vue?vue&type=template&id=38decfc0&scoped=true&"
import script from "./gamecenter.vue?vue&type=script&lang=js&"
export * from "./gamecenter.vue?vue&type=script&lang=js&"
import style0 from "./gamecenter.vue?vue&type=style&index=0&id=38decfc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38decfc0",
  null
  
)

export default component.exports